import { CSSObject, themeMediaRules } from '@common'
import { colors } from '@theme'
import type { HiddenOptions } from '@components/leader-line/leader-line'
export const DeviceSizes:DeviceSize[] = [
    'mobile', 'tablet', 'desktop'
]

type PointSpec = { x: number, y: number }

type Socket = 'top' | 'bottom' | 'left' | 'right'
export type Message = {
    title: string
    message: string
    externalSelector?: string
    position?: string
    align?: string
    justify?: string
    hideLine?: boolean
    style?: CSSObject
    pointTo?: PointSpec
    pointFrom?: PointSpec
    box?: { x: number, y: number, width: number, height: number }
    startSocket?: Socket
    endSocket?: Socket
    hidden?: HiddenOptions
    mobile?: Message
    tablet?: Message
    desktop?: Message
}

export type MessageBoxProps =  {
    hideLine?: boolean
    imageReady: boolean
    className?: string
    target: HTMLDivElement | null
    message: Message
    displaySize: DeviceSize
    deviceSize: DeviceSize
    sizes: DeviceSize[]
}

export type ExternalMessage = Message & {
    selector: string
}

export type ScreenshotsProps = {
    name: string
    caption?: string
    withNavbar?: boolean
    border?: boolean
    sizes?: DeviceSize[]
    messages: Message[]
}

export const LINE_COLOR = colors.blue2

export type DeviceSize = keyof typeof themeMediaRules
